import {Routes} from "@angular/router";

import {VueFactureAchatRechercheComponent} from "./vue-facture-achat-recherche/vue-facture-achat-recherche.component";

import {VueFactureVenteRechercheComponent} from "./vue-facture-vente-recherche/vue-facture-vente-recherche.component";

//Représent les routes facture
export const factureRoutes: Routes =
[
  {path: "recherche-facture-achat", component: VueFactureAchatRechercheComponent, outlet: "page"},
  {path: "recherche-facture-vente", component: VueFactureVenteRechercheComponent, outlet: "page"}
];